import { createSlice } from '@reduxjs/toolkit';

import { setUserInfo } from './user.action';

const initialState = {
  fullName: '',
  rut: ''
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(setUserInfo, (state, action) => {
        state.fullName = action.payload.fullName;
        state.rut = action.payload.rut;
      })
      .addDefaultCase(() => {})
});

export default userSlice.reducer;
